import React, { Fragment, useEffect } from "react";
import Header from "../../Header/Header";
import PageTitle from "../../pagetitle/PageTitle";
import Footer from "../../footer/Footer";
import Scrollbar from "../../scrollbar/scrollbar";
import Ecommerce from "./Ecommerce";

const Ecommercesinglepage: React.FC = () => {
    useEffect(() => {
        document.title = "Ecommerce | Brain Machine AI";
      }, []);
    return (
        <Fragment>
            <div className='about-page inner-page'>
                <div className="body_wrap o-clip">
                    <Header />
                    <main>
                    <PageTitle pageTitle="Ecommerce" pagesub="Ecommerce" />
                       <Ecommerce></Ecommerce>
                    </main>
                    <Footer />
                    <Scrollbar />
                </div>
            </div>
        </Fragment>
    );
};

export default Ecommercesinglepage;
